<template>
  <div class="message">
    <h3 class="m-2 p-0 font-weight-bold">{{title}}</h3>
    <hr class="m-2 p-0">
    <slot name="body"></slot>
  </div>
</template>

<script>
  export default {
    name: "Message",
    props: ["title"]
  }
</script>

<style scoped lang="scss">
  .message {
    text-align: center;
    width: 600px;
    height: 350px;
    border-radius: 9px;
    padding: 10px;
    box-shadow: 10px 10px 5px -5px rgba(0,0,0,0.3);
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: white;
    transform: translate(-50%, -50%);
    animation: fade 1.5s;
  }

  @keyframes fade {
    from{opacity: 0}
    to{opacity: 1}
  }



</style>
